import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blockchain-smart-contract',
  templateUrl: './blockchain-smart-contract.component.html',
  styleUrls: ['./blockchain-smart-contract.component.css']
})
export class BlockchainSmartContractComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
